module.exports = __webpack_public_path__ + "7ca856ad121ef25d15f7356a2138f587.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/login/img/premio-br-week-in.png
// module id = 1240
// module chunks = 0